import { Component, Input, OnInit } from "@angular/core";
import { AssistantSteps } from "../../../models";

@Component({
    selector: "app-assistant-popup-steps",
    templateUrl: "./assistant-popup-steps.component.html",
    styleUrls: ["./assistant-popup-steps.component.scss"],
    standalone: false
})
export class AssistantPopupStepsComponent implements OnInit {
  @Input() steps: AssistantSteps;

  constructor() {}

  ngOnInit(): void {}

  done(step: string): boolean {
    const indexOfCurrent = this.steps.steps.indexOf(this.steps.current);
    const indexOfStep = this.steps.steps.indexOf(step);

    return indexOfStep < indexOfCurrent;
  }

  current(step: string): boolean {
    return step === this.steps.current;
  }
}
